module.exports = __webpack_public_path__ + "img/n-shop.6f31bb2b.svg";